import { render, staticRenderFns } from "./tagsViews.vue?vue&type=template&id=6acf985d&scoped=true&"
import script from "./tagsViews.vue?vue&type=script&lang=js&"
export * from "./tagsViews.vue?vue&type=script&lang=js&"
import style0 from "./tagsViews.vue?vue&type=style&index=0&id=6acf985d&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./tagsViews.vue?vue&type=style&index=1&id=6acf985d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acf985d",
  null
  
)

export default component.exports